import { render } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import TeamCard from './TeamCard';
import SectionHeaderAlt from 'react-components/SectionHeaderAlt';

export async function Root(element, data) {
  function MeetTheTeam() {
    let { section_paragraph, section_heading, team_cards } = data;
    const swiperRef = useRef(null);

    useEffect(() => {
      if (swiperRef.current) {
        const swiper = swiperRef.current.swiper;

        const updateSlideClasses = () => {
          requestAnimationFrame(() => {
            swiper.slides.forEach((slide) => {
              if (slide.classList.contains('swiper-slide-active')) {
                slide.classList.remove(
                  // Active slide
                  'tw-opacity-75',
                  'tw-blur-[1.5px]',
                  'tw-h-[calc((100vw-71px)/1.1*.825)]',
                  'min-[400px]:tw-h-[calc((100vw-71px)/1.25*.825)]',
                  'min-[600px]:tw-h-[calc((100vw-71px)/2*.825)]',
                  'min-[768px]:tw-h-[calc((100vw-71px)/2.5*.825)]'
                );
                slide.classList.add(
                  'tw-opacity-100',
                  'tw-blur-none',
                  'tw-h-[calc((100vw-71px)/1.1)]',
                  'min-[400px]:tw-h-[calc((100vw-71px)/1.25)]',
                  'min-[600px]:tw-h-[calc((100vw-71px)/2)]',
                  'min-[768px]:tw-h-[calc((100vw-71px)/2.5)]'
                );
              } else {
                slide.classList.remove('tw-opacity-100', 'tw-blur-none');
              }
            });
          });
        };

        // Update classes on initial load
        updateSlideClasses();

        // Update classes on slide change
        swiper.on('slideChange', updateSlideClasses);

        // Force Swiper to reinitialize on resize
        swiper.on('resize', () => {
          swiper.update();
          updateSlideClasses();
        });

        // Cleanup event listeners on unmount
        return () => {
          swiper.off('slideChange', updateSlideClasses);
          swiper.off('resize', updateSlideClasses);
        };
      }
    }, []);

    return (
      <div className="tw-relative tw-mx-auto tw-w-full tw-max-w-[94.5rem] tw-overflow-hidden tw-bg-white tw-pb-[50px] tw-pt-64 tablet:tw-pb-[79px] tablet:tw-pt-[74px] min-[992px]:tw-px-16">
        <SectionHeaderAlt
          section_heading={section_heading}
          section_paragraph={section_paragraph}
          classes={'tw-max-w-[23.75rem] tablet:tw-max-w-[36.25rem] tw-mx-auto tw-mb-[1.25rem] tablet:tw-mb-[3.5rem]'}
        />
        <Swiper
          ref={swiperRef}
          className="tw-h-[calc((100vw-71px)/1.1)] tw-w-full min-[400px]:tw-h-[calc((100vw-71px)/1.25)] min-[600px]:tw-h-[calc((100vw-71px)/2)] min-[768px]:tw-h-[calc((100vw-71px)/2.5)] min-[992px]:tw-h-auto"
          loop={true}
          modules={[Autoplay]} 
          autoplay={{ delay: 3000 }}
          centeredSlides={true}
          keyboard={{ enabled: true, onlyInViewport: true }}
          spaceBetween={26}
          slidesPerView={1.2}
          grabCursor={true}
          breakpoints={{
            400: {slidesPerView: 1.35},
            480: { slidesPerView: 1.5 },
            600: { slidesPerView: 2.1 },
            768: { slidesPerView: 2.65 },
            992: { slidesPerView: 3 },
            1232: { slidesPerView: 4, centeredSlides: false },
          }}
        >
          {team_cards.map((teamCard, i) => (
            <SwiperSlide
              key={i}
              className="
                tw-my-auto tw-flex tw-h-[calc((100vw-71px)/1.1*.825)] tw-w-full tw-items-center 
                tw-overflow-hidden tw-opacity-75 tw-blur-[1.5px] 
                tw-transition-[height,opacity,filter] !tw-duration-300 tw-ease-in-out 
                tw-will-change-[height,opacity,filter] 
                min-[400px]:tw-h-[calc((100vw-71px)/1.25*.825)] 
                min-[600px]:tw-h-[calc((100vw-71px)/2*.825)] 
                min-[768px]:tw-h-[calc((100vw-71px)/2.5*.825)] 
                min-[992px]:tw-h-auto min-[992px]:tw-opacity-100 min-[992px]:tw-blur-none
              ">
              <div className="tw-size-full">
                <TeamCard
                  heading={teamCard.heading}
                  description={teamCard.description}
                  image={teamCard.image}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  }
  render(<MeetTheTeam />, element);
}